export default {
  init() {

  },
  finalize() {
    if ($('.booking-manager-wrap').length > 0) {

      $('.bm-sidebar-language-current').on('click', function() {
        $('.bm-sidebar-language-switcher-wrap').toggleClass('open');
      });

      var langSwitchUrl = $('.wpml-ls-item:not(.wpml-ls-current-language) a').attr('href');
      $('.bm-sidebar-language-switcher-other').attr('href', langSwitchUrl);

      // Mobile
      $('.tablet-bar-toggle-sidebar').on('click', function() {
        $('.bm-sidebar-wrap').addClass('open');
      });

      // Mobile close
      $(window).on('click', function(e) {
        if ($(e.target).hasClass('bm-sidebar-wrap')) {
          $('.bm-sidebar-wrap').removeClass('open');
        }
      });

      $('.bm-sidebar-close').on('click', function() {
        $('.bm-sidebar-wrap').removeClass('open');
      });

    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/bookingManager.js